<template>
  <div class="bg-grey-90 py-6 md:py-28">
    <div class="container md:grid md:cols-2 md:px-0 <md:flex <md:flex-col-reverse <md:gap-10 divide-grey-80" style="max-width: 45.375rem">
      <div class="md:flex md:center md:pr-12">
        <vf-features-list class="md:pr-12" :items="listItems" />
      </div>
      <div class="md:b-l md:pl-8">
        <form-simplified-enrollment :entry-point :form-location @resolve="$emit('resolve')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AccountGatewayEntryPoint, FormLocation } from '#types/gtm'

const { formLocation = 'inline:body:sign-in:none' } = defineProps<{
  entryPoint?: AccountGatewayEntryPoint
  formLocation?: FormLocation
}>()

defineEmits<{ resolve: [] }>()

const { $feature, $t } = useNuxtApp()

const listItems = computed(() => [
  {
    heading: $t.signInFeatures.heading1,
    text: replaceAll($t.signInFeatures.text1, {
      percent: $feature.configSignUp?.loyaltyRewardPercent ?? 10,
    }),
  },
  {
    heading: $t.signInFeatures.heading2,
    text: $t.signInFeatures.text2,
  },
  {
    heading: $t.signInFeatures.heading3,
    text: $t.signInFeatures.text3,
  },
])
</script>
